module.exports = __webpack_public_path__ + "static/media/shareLockGuide2_Jap.698fee12.jpg";